import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Box } from '@mui/material';
import InfoBox from '../../../components/shared/boxes/InfoBox';
import MainSubtitle from '../../../components/shared/typography/MainSubtitle';
import Paragraph from '../../../components/shared/typography/Paragraph';
import OmieCard from './omie/OmieCard';
import ContaAzulCard from './conta_azul/ContaAzulCard';

const contactIntercom = () => {
  // Com uma possível mudança do front-end, a conexão com Intercom precisará ser investigada.
  Intercom(
    'showNewMessage',
    'Olá! Tenho interesse em contratar o módulo “Integração com o ERP”. Poderia me informar quais as informações necessárias?'
  );
};

const ERPSection = () => {
  const [contractedModule, updateContractedModule] = useState(undefined);

  useEffect(() => {
    const fetchModuleStatus = async () => {
      await axios.get('/integrations/erp/module_status.json')
        .then((response) => {
          const { module } = response.data;
          updateContractedModule(module);
        })
    }
    fetchModuleStatus()
  }, [])

  const mainBoxSx = {
    display: 'flex',
    flexDirection: 'column',
    gap: '32px',
  };

  return (
    <Box sx={mainBoxSx}>
      {contractedModule && contractedModule === 'none' && (
        <InfoBox
          title={'Contrate o módulo “Integração com ERP” para conectar sua conta com outros sistemas.'}
          link={{ title: 'Contratar', onClick: () => contactIntercom() }}
        />
      )}

      <Box>
        <MainSubtitle sx={{ marginBottom: '8px' }}>Integração com ERP</MainSubtitle>
        <Paragraph>
          É possível integrar o Produttivo com dois dos principais ERPs SaaS utilizados no mercado para resolver a perda
          de tempo ao lançar informações em outro sistema para faturar e controlar estoque.
        </Paragraph>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <OmieCard />
        <ContaAzulCard />
      </Box>
    </Box>
  );
};

export default ERPSection;
